import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después del pago recibís un mail con el link de descarga de todos los PDFs. El acceso es de por vida.'
}, {
  q: '¿Sirve si soy pediatra general y no especialista en salud mental?',
  a: 'Exactamente para eso está diseñado. Este sistema no te convierte en psiquiatra. Te da las herramientas para detectar, documentar y derivar correctamente, que es exactamente lo que se espera de un pediatra ante una señal de salud mental.'
}, {
  q: '¿Está en español argentino?',
  a: 'Todo el contenido está escrito en español rioplatense, adaptado a la legislación argentina, con referencias a la Ley 26.061, el sistema judicial de familia argentino y los organismos de protección del país.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos tanto en el PRO como en el Elite. La diferencia es el Blindaje Legal Pediátrico Total que se suma en la opción Elite.'
}, {
  q: '¿Sirve para el concurso de residencia de pediatría?',
  a: 'Sí. El manejo de situaciones de salud mental, el conocimiento del marco legal específico y los protocolos clínicos te diferencian en la evaluación del concurso.'
}, {
  q: '¿Qué diferencia tiene con los libros de pediatría tradicionales?',
  a: 'Los libros de pediatría dedican poco espacio a salud mental y ninguno contempla la complejidad legal de detectar y actuar ante estas situaciones en Argentina. Este sistema está diseñado exclusivamente para eso.'
}, {
  q: '¿Para qué nivel está pensado?',
  a: 'Para pediatras en consultorio privado y hospital público, residentes de pediatría, médicos generalistas que atienden niños y profesionales que se preparan para el concurso de residencia pediátrica.'
}, {
  q: '¿Por qué elegir el Elite y no el PRO base?',
  a: 'El PRO te da todo el sistema clínico. El Elite agrega el sistema de protección legal para los casos donde algo salió mal o podría salir mal. Si atendés niños, la pregunta no es si vas a enfrentar una situación legal compleja sino cuándo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-slate-50 py-8 sm:py-28" data-id="element-139">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-6 sm:mb-16" data-id="element-141">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-slate-500 uppercase mb-1.5 sm:mb-3" data-id="element-142">
            Dudas Comunes
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-143">
            Preguntas Frecuentes
          </p>
        </div>

        <div className="space-y-2 sm:space-y-4" data-id="element-144">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-white rounded-xl sm:rounded-2xl ring-1 transition-all ${isOpen ? 'ring-blue-200 shadow-md' : 'ring-slate-200 shadow-sm hover:ring-slate-300'}`} data-id="element-145">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left px-3 py-3 sm:px-6 sm:py-5 flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-xl sm:rounded-2xl" aria-expanded={isOpen} data-id="element-146">
                  <span className="font-semibold text-xs sm:text-base text-slate-900 pr-3 sm:pr-8" data-id="element-147">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-3.5 h-3.5 sm:w-5 sm:h-5 text-slate-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180 text-blue-500' : ''}`} data-id="element-148" />
                </button>
                <AnimatePresence data-id="element-149">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-150">
                      <div className="px-3 pb-3 sm:px-6 sm:pb-5 text-[10px] sm:text-base text-slate-600 leading-relaxed" data-id="element-151">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}